export enum SuppliesInventoryConfigStatus {
  Active = "active",
  Paused = "paused",
}
